import React from 'react';
import { Section } from './ui/Section';
import { FileText, CheckSquare, ShieldCheck, Zap, Clock } from 'lucide-react';
export function IncludesSection() {
  const bonuses = [{
    icon: CheckSquare,
    title: 'Checklist Pre‑Trade'
  }, {
    icon: FileText,
    title: 'Checklist Post‑Trade'
  }, {
    icon: ShieldCheck,
    title: 'Mis Reglas de Trader + Contrato'
  }, {
    icon: Zap,
    title: 'Protocolo Anti‑Revenge'
  }, {
    icon: Clock,
    title: 'Rutina Mañana + Cierre'
  }];
  return <Section background="accent" className="relative overflow-hidden" data-id="element-76">
      <div className="absolute top-0 right-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 pointer-events-none" data-id="element-77"></div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-78">
        <div data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-80">
            Qué incluye el pack completo
          </h2>
          <p className="text-slate-300 text-lg mb-8" data-id="element-81">
            No es solo lectura. Es un kit de herramientas para aplicar
            inmediatamente.
          </p>

          <div className="space-y-6" data-id="element-82">
            <div className="flex items-center p-4 bg-slate-900/50 rounded-xl border border-slate-700" data-id="element-83">
              <div className="h-12 w-12 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold text-xl mr-4 shadow-lg shadow-blue-500/20" data-id="element-84">
                PDF
              </div>
              <div data-id="element-85">
                <h3 className="text-white font-bold text-lg" data-id="element-86">
                  Ebook Anti FOMO Trader
                </h3>
                <p className="text-slate-400" data-id="element-87">
                  5 Capítulos de pura ejecución práctica
                </p>
              </div>
            </div>

            <div className="pl-4 border-l-2 border-blue-500/30 space-y-4" data-id="element-88">
              <h4 className="text-blue-400 font-semibold uppercase tracking-wider text-sm" data-id="element-89">
                + 5 Bonos Imprimibles
              </h4>
              <ul className="space-y-3" data-id="element-90">
                {bonuses.map((bonus, i) => <li key={i} className="flex items-center text-slate-300" data-id="element-91">
                    <bonus.icon className="h-5 w-5 text-blue-500 mr-3" data-id="element-92" />
                    {bonus.title}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="relative" data-id="element-93">
          {/* Visual representation of the bundle */}
          <div className="grid grid-cols-2 gap-4" data-id="element-94">
            <div className="bg-slate-900 p-6 rounded-lg border border-slate-700 transform rotate-2 hover:rotate-0 transition-transform duration-300 shadow-xl" data-id="element-95">
              <div className="h-32 bg-slate-800 rounded mb-3 animate-pulse" data-id="element-96"></div>
              <div className="h-4 w-3/4 bg-slate-700 rounded mb-2" data-id="element-97"></div>
              <div className="h-4 w-1/2 bg-slate-700 rounded" data-id="element-98"></div>
            </div>
            <div className="bg-slate-900 p-6 rounded-lg border border-slate-700 transform -rotate-2 hover:rotate-0 transition-transform duration-300 shadow-xl translate-y-8" data-id="element-99">
              <div className="h-32 bg-slate-800 rounded mb-3 animate-pulse" data-id="element-100"></div>
              <div className="h-4 w-3/4 bg-slate-700 rounded mb-2" data-id="element-101"></div>
              <div className="h-4 w-1/2 bg-slate-700 rounded" data-id="element-102"></div>
            </div>
          </div>

          <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-103">
            <div className="bg-blue-600 text-white font-bold py-2 px-6 rounded-full shadow-xl transform rotate-12 border-2 border-slate-900" data-id="element-104">
              VALOR TOTAL: 97€
            </div>
          </div>
        </div>
      </div>
    </Section>;
}